import Events from 'root/helpers/events';

export default function LoadingIndicator({ form = null, loaderParentEl = null } = {}) {
    const loadingIndicatorDataAttribute = '[data-loader=ls-loader]';
    const data = {
        el:
            form && form.closest('.leadform')
                ? form.closest('.leadform').querySelector(loadingIndicatorDataAttribute)
                : document.querySelector(loadingIndicatorDataAttribute),
    };

    if (data.el) {
        data.closeButton = data.el.querySelector('[data-button="back-to-form"]');
        data.error = data.el.querySelector('[data-select="form-landing-error"]');
        data.happy = data.el.querySelector('[data-select="form-landing-happy"]');

        return {
            start,
            showError,
            create,
            hide,
            showSuccessMessage,
        };
    }

    function _getRandomIndex(len) {
        return Math.floor(Math.random() * len);
    }

    function _show() {
        if (data.el) {
            _displayElement(data.el, 'block');
            _scrollTop(data.el);
        }
        const backToFormButton = data.el.querySelector('a[data-button="back-to-form"]');
        backToFormButton &&
            backToFormButton.addEventListener('click', _backToForm.bind(this));

        if (data.closeButton) {
            _displayElement(data.closeButton, 'none');
        }
    }

    function _backToForm(e) {
        e.preventDefault();
        Events.fire(e, 'back_to_form');
        // Hide the eventfeedback messaging and show form
        const formSectionDataAttribute = '[data-form="form-section"]';
        const buyNowDemoForm = document.querySelector('[data-form-name=buy_now]');
        const fallBackSection = document.querySelector(formSectionDataAttribute);

        const formSection =
            form && form.closest('.leadform')
                ? form.closest('.leadform').querySelector(formSectionDataAttribute)
                : fallBackSection
                ? fallBackSection
                : buyNowDemoForm;

        if (data.happy) {
            _displayElement(data.happy, 'flex');
        }
        if (formSection) {
            _displayElement(formSection, 'block');
        }

        if (data.error) {
            _displayElement(data.error, 'none');
        }
        if (data.el) {
            _displayElement(data.el, 'none');
            _scrollTop(data.el);
        }
    }

    function _displayElement(element, display) {
        element && (element.style.display = display);
    }

    function _scrollTop(element) {
        if (element.dataset.scroll !== 'false') {
            window.scrollTo(0, 0);
        }
    }

    function _loaderBaseHTML() {
        return `
    <div class="form-event-feedback col-xs-12" style="display:block">
        <div class="form-event-feedback__content">
            <div class="form-event-feedback__loading" >
                <div class="form-event-feedback__loading-animation">
                    <div class="form-event-feedback__loading-animation__dots">
                        <div class="form-event-feedback__loading-animation__dots__dot1"></div>
                        <div class="form-event-feedback__loading-animation__dots__dot2"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `;
    }

    function create() {
        const loaderEl = document.createElement('div');
        loaderEl.classList.add('js-loader');
        loaderEl.classList.add('col-xs-12');
        loaderEl.innerHTML = _loaderBaseHTML();
        if (loaderParentEl) {
            loaderParentEl.append(loaderEl);
        }
    }

    function hide() {
        const loaderEl = document.querySelector('.js-loader') || data.el;
        if (loaderEl) {
            loaderEl.style.display = 'none';
            loaderEl.classList.remove('js-loader');
        }
    }

    function start(loaderOnly = false) {
        if (data.el && !loaderOnly) {
            _show();
            setTimeout(cycleThroughMessages(), 1000);
        } else {
            _show();
        }
    }

    function cycleThroughMessages() {
        const messageEl = data.el.querySelector('[data-loader-message]');
        const messageJson = messageEl && messageEl.dataset.loaderMessage;
        const messageObjectsArray = messageJson && JSON.parse(messageJson);
        let randomIndex =
            messageObjectsArray &&
            messageObjectsArray.length > 0 &&
            _getRandomIndex(messageObjectsArray.length);
        let cycleTimeoutID = null;

        const changeMessage = function () {
            if (randomIndex && messageEl && messageObjectsArray) {
                messageEl.style.opacity = 0;
                messageEl.innerHTML = messageObjectsArray[randomIndex]?.message_text;
                messageEl.style.opacity = 1;
                randomIndex = (randomIndex + 1) % messageObjectsArray.length;

                clearTimeout(cycleTimeoutID);
                cycleTimeoutID = setTimeout(changeMessage, 3200);
            }
        };

        return changeMessage;
    }

    function showSuccessMessage() {
        const successMessageDataAttribute = '[data-feedback=success-message]';
        const successMessage =
            form && form.closest('.leadform')
                ? form.closest('.leadform').querySelector(successMessageDataAttribute)
                : document.querySelector(successMessageDataAttribute);
        if (successMessage) {
            successMessage.style.display = 'block';
        }
    }

    function showError() {
        if (data.el) {
            _displayElement(data.happy, 'none');
            _displayElement(data.error, 'flex');
            if (data.closeButton) {
                _displayElement(data.closeButton, 'inline-block');
            }
        }
    }
}
